export const OMIT_VARIABLES_FROM_SENTRY_CONTEXT_KEY = 'omitVariablesFromSentry'
